import { Component, OnInit } from '@angular/core';
import { HotkeysService } from 'src/app/_services/hotkeys.service';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-create-hotkey',
  templateUrl: './create-hotkey.component.html',
  styleUrls: ['./create-hotkey.component.scss'],
})
export class CreateHotkeyComponent implements OnInit {
  loading: boolean = false;
  // Column limits (models.py Hotkeys): hotkey_main VARCHAR(6), hotkey_tag
  // VARCHAR(8), main_description VARCHAR(30), tag_description VARCHAR(100).
  // Postgres rejects an over-length value outright (no truncation) and the
  // generic CRUD route has no error handling around that, so exceeding
  // these crashes the request instead of showing a validation message -
  // enforce the same limits here so that can't happen.
  hotkeyForm = this.fb.group({
    hotkey_main: ['', [Validators.required, Validators.maxLength(6)]],
    hotkey_tag: [''],
    main_description: ['', [Validators.required, Validators.maxLength(30)]],
    tag_description: [''],
    tags: this.fb.array([]),
  });

  constructor(
    private hotkeysService: HotkeysService,
    private fb: FormBuilder,
    public ref: DynamicDialogRef,
    public messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.hotkeyForm = this.fb.group({
      hotkey_main: ['', [Validators.required, Validators.maxLength(6)]],
      hotkey_tag: [''],
      main_description: ['', [Validators.required, Validators.maxLength(30)]],
      tag_description: [''],
      tags: this.fb.array([]),
    });
  }

  get tagsArray() {
    return this.hotkeyForm.get('tags') as FormArray;
  }

  addTag() {
    this.tagsArray.push(
      this.fb.group({
        hotkey_tag: ['', [Validators.required, Validators.maxLength(8)]],
        tag_description: ['', [Validators.required, Validators.maxLength(100)]],
      })
    );
  }

  removeTag(index: number) {
    this.tagsArray.removeAt(index);
  }

  createHotkey() {
    this.loading = true;

    if (this.hotkeyForm.invalid) {
      this.hotkeyForm.markAllAsTouched();
      this.loading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill in all the required fields',
        key: 'hotkeys',
      });
      return;
    }

    const formValue: any = this.hotkeyForm.getRawValue();
    const baseHotkey = {
      hotkey_main: formValue.hotkey_main,
      main_description: formValue.main_description,
      hotkey_tag: '',
      tag_description: '',
    };
    const tags = formValue.tags || [];
    const requests = [
      this.hotkeysService.addHotkey(baseHotkey),
      ...tags.map((tag: any) =>
        this.hotkeysService.addHotkey({
          ...baseHotkey,
          hotkey_tag: tag.hotkey_tag,
          tag_description: tag.tag_description,
        })
      ),
    ];

    forkJoin(requests).subscribe(
      (data) => {
        this.hotkeysService.getHotkeys().subscribe((data) => {
          this.hotkeysService.updateHotkeys(data);
        });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred while creating the hotkey',
          key: 'hotkeys',
        });
      },
      () => {
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Hotkey created successfully',
          key: 'hotkeys',
        });
        this.ref.close();
      }
    );
  }
}
